import type { CreateTarget } from './Action';

/**
 * Build a `?zoneId=…&folderId=…` query suffix from a Workspace create pre-target
 * so a route- or `window.open`-based create page can seed its zone / folder.
 * Empty string when there is no pre-target (list pages), so the URL is
 * unchanged. `folderId` is omitted when null (a zone-root create).
 */
export const createInQuery = (createIn?: CreateTarget): string => {
  if (!createIn) return '';
  const params = new URLSearchParams();
  // Both id and name — route create pages key the zone by one or the other.
  params.set('zoneId', String(createIn.zoneId));
  params.set('zoneName', createIn.zoneName);
  if (createIn.folderId != null) params.set('folderId', String(createIn.folderId));
  return `?${params.toString()}`;
};
